import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CommonApiService {
  constructor(private http: HttpClient) {}

  commonPostMethod(data, url, options) {
    return this.http.post(url, data, options);
  }

  commonGetMethod() {
    return this.http.get(environment.url + 'all-users');
  }

  commonDeleteMethod(url, options) {
    return this.http.delete(environment.url + url, options);
  }

  paymentGetMethod(url) {
    return this.http.get(url);
  }
}
